module.exports = __webpack_public_path__ + "media/Images/One-Digital-Black-dff93f5e3a264292fc94735cfc3d00f1.png";